import { render, staticRenderFns } from "./shipingtonghua.vue?vue&type=template&id=56f3fd1e&scoped=true&"
import script from "./shipingtonghua.vue?vue&type=script&lang=js&"
export * from "./shipingtonghua.vue?vue&type=script&lang=js&"
import style0 from "./shipingtonghua.vue?vue&type=style&index=0&id=56f3fd1e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f3fd1e",
  null
  
)

export default component.exports